module.exports = __webpack_public_path__ + "img/DW365-142.ce15f587.jpg";